<!-- 组合推荐的子组件：swiper商品 -->
<template>
  <div class="swiper-product-card">
    <!-- PC端的组合推荐标题 -->
    <div class="swiper-product-card__title">
      <div>{{title}}</div>
    </div>
    <div class="swiper-product-card__body" v-if="products.length>0">
      <swiper
        ref="mySwiper"
        class="swiper"
        :options="mbConfig?mbConfig:swiperOption"
      >
        <swiper-slide
          v-for="list in products"
          :key=" list.ID"
          :class="[products.length < 2?'isSwiperOne':'']"
        >
          <!-- 商品卡片 -->
          <v-product-card
            :productDetail="list"
            :show_currency_selector="showCurrencySelector"
            :disable_select="true"
            :show_star="true"
            :theme="$store.state.theme_name"
            :comment="cardConfig.show_star?comment:null"
            :card_radio="cardConfig.card_radio"
            :cart_type="cartConfig.type"
            :card_animate="cardConfig && cardConfig.card_animate ? cardConfig.card_animate : 'default'"
            :text_align="cardConfig.text_align"
            :palette_config="paletteConfig"
            :custom_button="list.custom_button && list.custom_button.custom_button"
            :buy_button_style="cardConfig.buy_button_style"
            sales_label="default"
            :sale_image="cardConfig.sale_image"
            :sale_image_show="cardConfig && cardConfig.sale_image_show"
            :isShowMainImg="true"
            :font_size="cardConfig.font_size"
            :product_price="cardConfig && cardConfig.product_price"
          ></v-product-card>
        </swiper-slide>
        <div
          class="swiper-pagination swiper-pagination-black"
          slot="pagination"
        ></div>
        <div
          class="swiper-button-prev swiper-button-black"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button-black"
          slot="button-next"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SwiperProductCard',
  props: {
    //商品列表
    products: {
      type: Array,
      default: null
    },
    //组合推荐的标题
    title: {
      type: String,
      default: null
    },
    //评论模块
    comment: {
      type: Object,
      default: null
    },
    //当前显示的商品id
    currentProductId: {
      type: Number,
      default: null
    },
    //调色板模块
    paletteConfig:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      //swiper配置
      swiperOption: {
        initialSlide: 0,
        slidesPerView: 1,
        autoplay: false,
        spaceBetween: 0,
        // on: {
        //   slideChangeTransitionEnd: this.handChangeEnd,
        // },
        pagination: {
          el: `.swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true,
        observeParents: true,
      },
    }
  },
  mounted() {
    //监听屏幕宽度，在小于767时swiper显示1.3个商品
    // if(document.body.clientWidth <= 767){
    //   this.swiper.params.slidesPerView = 1.3
    // }
    window.onresize = ()=>{
      if(!this.swiper) return;
      this.$nextTick(() => {
        if(document.body.clientWidth <= 767){
          this.swiper.params.slidesPerView = 1.4
        }else{
          this.swiper.params.slidesPerView = 1
        }
      })
    }
  },
  computed: {
    //swiper对象
    swiper() {
        // mySwiper 可能为空
      return this.$refs.mySwiper?.swiper;
    },
    mbConfig() {
      if( document.body.clientWidth <= 767) {
         let newConfig =  this.swiperOption;
         newConfig.slidesPerView = 1.4
         return newConfig
      }else {
        return null
      }
    },
     //商品卡片配置 $cart_type = is_string(config('themes_default.global.cart.type')) ? config('themes_default.global.cart.type') : 'page';
    ...mapState({
      cardConfig: ({ options }) => options?.theme?.global?.product_cart ,
      cartConfig: ({ options }) => options?.theme?.global?.cart ,
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector?true:false
    })
  },
  watch: {
    //当显示商品id发生改变 ，swiper显示商品跟随变化
    currentProductId(newValue){
      this.products.map((item, index)=>{
        if(item.ID == newValue){
          this.swiper?.slideTo(index, 1000, false);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-product-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  &__title {
    font-size: 20px;
    font-weight: bold;
    color: #222A40;
    margin-bottom: 34px;
  }
  &__body {
    max-width: calc(50% + 104px);
    width: calc(50% + 104px);
    .swiper {
      padding-bottom: 15px;
      .swiper-slide {
        padding-left: 52px;
        padding-right: 52px;
        div {
          box-shadow: 0px 0px 6px 0px rgba(108, 108, 108, 0.14);
          &::v-deep {
            .product_price_cross {
              line-height: 1;
            }
            .product_details {
              .product_title {
                line-height: normal;
              }
            }
          }
        }
      }
      .swiper-button-prev,.swiper-button-next {
        background-size: 12px 22px !important;
      }
    }
  }
}
@media (max-width: 767px) {
  .swiper-product-card {
    &__title{
      display: none;
    }
    &__body {
      margin-top: 15px;
      max-width: 100%;
      width: 100%;
      .swiper {
        margin-left: 15px;
        overflow: unset;
        .swiper-slide {
          padding-left: 0px;
          padding-right: 15px;
        }
        .isSwiperOne{
          width: 100vw !important;
        }
        .swiper-pagination,.swiper-button-prev,.swiper-button-next {
          display: none;
        }
      }
    }
  }
}
</style>
